module.exports = __webpack_public_path__ + "static/media/closeReplyMessageIcon.1f1cd3b7.svg";